import type { RunReport } from '@/api/supplier-price-lists/supplier-price-lists.types';

/** Offers an incomplete-looking run did not contain: active before minus seen. */
export const missingOffers = (run: RunReport) =>
  Math.max(0, (run.rowsActiveBefore ?? 0) - (run.rowsSeen ?? 0));

export const fmtCount = (n: number) => n.toLocaleString('de-DE');

/** "1 Angebot", "2.120 Angebote". */
export const offersText = (n: number) =>
  `${fmtCount(n)} ${n === 1 ? 'Angebot' : 'Angebote'}`;

/** "1 fehlendes Angebot", "3 fehlende Angebote". */
export const missingOffersText = (n: number) =>
  n === 1 ? '1 fehlendes Angebot' : `${fmtCount(n)} fehlende Angebote`;

export const fmtDateTime = (iso: string) =>
  new Date(iso).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
